"use strict";
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.withDefaults = void 0;
/** Fills in missing options with their default values */
function withDefaults(opts) {
    var _a;
    return { includePseudoElements: (_a = opts.includePseudoElements) !== null && _a !== void 0 ? _a : false };
}
exports.withDefaults = withDefaults;
//# sourceMappingURL=options.js.map